const iosCopyToClipboard = (link: string) => {
    const textArea = document.createElement('textarea');
    textArea.value = link;
    document.body.appendChild(textArea);

    const range = document.createRange();
    range.selectNodeContents(textArea);

    const selection = window.getSelection();
    selection?.removeAllRanges();
    selection?.addRange(range);
    textArea.setSelectionRange(0, 999999);

    document.execCommand('copy');
    document.body.removeChild(textArea);
};

const isApple = () => navigator.vendor.indexOf('Apple') > -1;

const copyAsync = (text: string) => navigator.clipboard.writeText(text);

export const copyToClipboard = async (link: string) => (isApple() ? iosCopyToClipboard(link) : await copyAsync(link));
